import React from 'react';
import ReportPermissionChecker from './components/ReportPermissionChecker';
import EditReportV2 from './v2/components/EditReport';
import EditReportV3 from './v3/components/EditReport';
import { getStorageReport } from './utils';

const EditReport: React.FC = () => {
  const { type } = getStorageReport();

  return (
    <ReportPermissionChecker mode="edit">
      <>
        {type === '1' && <EditReportV2 />}
        {type === '3' && <EditReportV3 />}
      </>
    </ReportPermissionChecker>
  );
};

export default EditReport;
